import { Component, Input, OnInit } from '@angular/core';

@Component({
   selector: 'app-foster-family',
   templateUrl: './foster-family.component.html',
   styleUrls: ['./foster-family.component.scss'],
})
export class FosterFamilyComponent implements OnInit {
   @Input() members: any[] = [];

   constructor() {}

   ngOnInit(): void {}
}
